var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-active-filters',{attrs:{"activeFilters":_vm.activeFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }